import { redirectAvailabilityErrorOr404, goToDashboard } from '@/helpers/redirects';
import { EErrorType, EErrorScope, EErrorBlock, EErrorSeverity } from '@/helpers/enums';
import { hideModal } from '@/helpers/errors';

import i18n from '@/plugins/i18n';

export const errors = [
  {
    type: EErrorType.availability,
    code: 1000,
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'oferta-indisponivel.png',
      title: i18n.t('App.Checkout.availability.error.title'),
      message: i18n.t('App.Checkout.availability.error.code.1000'),
      buttonLabel: i18n.t('App.Checkout.availability.error.button'),
      buttonAction: redirectAvailabilityErrorOr404
    },
  },
  {
    type: EErrorType.availability,
    code: 1001,
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'oferta-indisponivel.png',
      title: i18n.t('App.Checkout.availability.error.title'),
      message: i18n.t('App.Checkout.availability.error.code.1001'),
      buttonLabel: i18n.t('App.Checkout.availability.error.button'),
      buttonAction: redirectAvailabilityErrorOr404
    },
  },
  {
    type: EErrorType.availability,
    code: 1002,
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'oferta-indisponivel.png',
      title: i18n.t('App.Checkout.availability.error.title'),
      message: i18n.t('App.Checkout.availability.error.code.1002'),
      buttonLabel: i18n.t('App.Checkout.availability.error.button'),
      buttonAction: redirectAvailabilityErrorOr404
    },
  },
  {
    type: EErrorType.availability,
    code: 'default',
    scope: EErrorScope.global,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'oferta-indisponivel.png',
      title: i18n.t('App.Checkout.availability.error.title'),
      message: i18n.t('App.Checkout.availability.error.code.default'),
      buttonLabel: i18n.t('App.Checkout.availability.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1100,
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'ja-possui-o-produto.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1100'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.button'),
      buttonAction: goToDashboard
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1101,
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'ja-possui-o-produto.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1101'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.button'),
      buttonAction: goToDashboard
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1102,
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'ja-possui-o-produto.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1102'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.button'),
      buttonAction: goToDashboard
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1103,
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'ja-possui-o-produto.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1103'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.button'),
      buttonAction: goToDashboard
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1104,
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'ja-possui-o-produto.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1104'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.button'),
      buttonAction: goToDashboard
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1200,
    scope: EErrorScope.global,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'algo-deu-errado.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1200'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.back'),
      buttonAction: (code: number | string) => hideModal(code, true)
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1201,
    scope: EErrorScope.global,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'algo-deu-errado.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1201'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.back'),
      buttonAction: (code: number | string) => hideModal(code, true)
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1202,
    scope: EErrorScope.global,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'error-security-blocked-purchase.png',
      title: i18n.t('App.Checkout.eligibility.error.blocked_purchase.title'),
      message: i18n.t('App.Checkout.eligibility.error.blocked_purchase.code.1202'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.blocked_purchase.understood'),
      buttonAction: (code: number | string) => hideModal(code, true)
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1203,
    scope: EErrorScope.global,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'algo-deu-errado.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1203'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.back'),
      buttonAction: (code: number | string) => hideModal(code, true)
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1204,
    scope: EErrorScope.global,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'algo-deu-errado.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1204'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.back'),
      buttonAction: (code: number | string) => hideModal(code, true)
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1205,
    scope: EErrorScope.global,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'algo-deu-errado.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1205'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.back'),
      buttonAction: (code: number | string) => hideModal(code, true)
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1206,
    scope: EErrorScope.global,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'algo-deu-errado.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1206'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.back'),
      buttonAction: (code: number | string) => hideModal(code, true)
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1301,
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'algo-deu-errado.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1301'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.button'),
      buttonAction: goToDashboard
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1302,
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'algo-deu-errado.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1302'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.button'),
      buttonAction: goToDashboard
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1303,
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'renovacao-negada.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1303'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.button'),
      buttonAction: goToDashboard
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1304,
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'renovacao-negada.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1304'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.button'),
      buttonAction: goToDashboard
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1305,
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'renovacao-negada.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1305'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.button'),
      buttonAction: goToDashboard
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1306,
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'algo-deu-errado.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1306'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.button'),
      buttonAction: goToDashboard
    },
  },
  {
    type: EErrorType.eligibility,
    code: 'expiredLink',
    scope: EErrorScope.global,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'algo-deu-errado.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.expiredLink'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.eligibility,
    code: 'default',
    scope: EErrorScope.global,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'algo-deu-errado.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.default'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: '05',
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.5'),
      buttonLabel: i18n.t('App.Checkout.payment.error.button'),
      buttonAction: (code: number | string) => hideModal(code, true)
    },
  },
  {
    type: EErrorType.payment,
    code: 'FA',
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.FA'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 9999,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.9999'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: '06',
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.06'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1000,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1000'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1005,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1005'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1009,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1009'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 2005,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.2005'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 57,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.57'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1019,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1019'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1022,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1022'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 2004,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.2004'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 2000,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.2000'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 2007,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.2007'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 2008,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.2008'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 2009,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.2009'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1003,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1003'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1007,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1007'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1008,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1008'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1021,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1021'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1023,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1023'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 2003,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.2003'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 51,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.51'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 70,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.70'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1016,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1016'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 54,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.54'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 'BV',
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.BV'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1001,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1001'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 2001,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.2001'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 'N7',
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.N7'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1045,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1045'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 14,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.14'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1011,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1011'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1014,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1014'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1042,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1042'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1015,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1015'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 'AC',
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.AC'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 12,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.12'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 9102,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.9102'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 78,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.78'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1025,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1025'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: '04',
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.04'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: '07',
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.07'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 41,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.41'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 43,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.43'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1017,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1017'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 55,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.55'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1006,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1006'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 2006,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.2006'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1010,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1010'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 'EE',
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.EE'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1013,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1013'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 9112,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.9112'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 9108,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.9108'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 15,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.15'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 9111,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.9111'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 98,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.98'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 9109,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.9109'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: '01',
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.01'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1002,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'error-security-mp.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1002'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1004,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1004'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1020,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1020'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1024,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1024'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 2002,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.2002'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 62,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.62'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 'CB',
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.CB'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 'UB',
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.UB'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 'IPB',
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.IPB'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.payment,
    code: 1203,
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.1203'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code, true)
    },
  },
  {
    type: EErrorType.payment,
    code: 'default',
    scope: EErrorScope.payment,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'payment-error.png',
      title: i18n.t('App.Checkout.payment.error.title'),
      message: i18n.t('App.Checkout.payment.error.code.default'),
      buttonLabel: i18n.t('App.Checkout.payment.error.understood'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.loading,
    code: 'default',
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'algo-deu-errado.png',
      title: i18n.t('App.Checkout.loading.error.title'),
      message: i18n.t('App.Checkout.loading.error.code.default'),
      buttonLabel: i18n.t('App.Checkout.loading.error.button'),
      buttonAction: redirectAvailabilityErrorOr404
    },
  },
  {
    type: EErrorType.loadingTerms,
    code: 'default',
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'algo-deu-errado.png',
      title: i18n.t('App.Checkout.loadingTerms.error.title'),
      message: i18n.t('App.Checkout.loadingTerms.error.code.default'),
      buttonLabel: i18n.t('App.Checkout.loadingTerms.error.button'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.general,
    code: 'default',
    scope: EErrorScope.global,
    block: EErrorBlock.none,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'algo-deu-errado.png',
      title: i18n.t('App.Checkout.loading.error.title'),
      message: i18n.t('App.Checkout.loading.error.code.default'),
      buttonLabel: i18n.t('App.Checkout.loading.error.button'),
      buttonAction: (code: number | string) => hideModal(code)
    },
  },
  {
    type: EErrorType.eligibility,
    code: 1400,
    scope: EErrorScope.global,
    block: EErrorBlock.all,
    severity: EErrorSeverity.warning,
    isOtherPaymentMethodsEnabled: false,
    informative: {
      image: 'algo-deu-errado.png',
      title: i18n.t('App.Checkout.eligibility.error.title'),
      message: i18n.t('App.Checkout.eligibility.error.code.1400'),
      buttonLabel: i18n.t('App.Checkout.eligibility.error.button'),
      buttonAction: goToDashboard
    },
  },
];
